import { Button, Col, Row, Tabs } from 'antd';
import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import Drawer from 'components/Drawer';
import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';

export const DrawerStyled = styled(Drawer)`
  & .ant-drawer-content-wrapper {
    width: 420px !important;
    padding: 0;
    @media (max-width: ${breakpoints.md}) {
      width: 100% !important;
      min-width: 0 !important;
    }
  }
`;

export const DetailContainerStyled = styled.div`
  margin-bottom: 30px;
`;

export const LabelStyled = styled.span`
  font-weight: 500;
  display: block;
  margin-bottom: 10px;
`;

export const InfoTextStyled = styled.div`
  font-size: 15px;
  color: #aaaaaa;
`;

export const NavTabContainerStyled = styled.div<{ $isFirst?: boolean; $width?: string; $active?: boolean }>`
  cursor: pointer;
  text-align: center;
  border: 1px solid #e5e5e5;
  ${({ $isFirst }) => ($isFirst ? '' : 'border-left-color: transparent;')}
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  flex: 0 0 ${({ $width }) => $width || 'auto'};
  ${({ $active }) => ($active ? 'border-color: #038FDE;' : '')}
`;

export const BaseLayoutContainerStyled = styled(Row)`
  padding: 25px;
  height: 100%;
`;

export const InfoExtraTextStyled = styled.span`
  font-weight: 400;
  margin-right: 5px;
`;

// use to calculate width for worktime
const calculateOccupiedWidth = (index: number, limitPerLine: number) => {
  const baseWidth = 110;
  const occupiedIndex = index % limitPerLine;
  return baseWidth + 120 * (occupiedIndex - 1);
};
const getWorktimeStyles = (index: number, limitPerLine: number, isLastItem?: boolean) => {
  const lastItemStyle = isLastItem ? '&::after {border: none}' : '';
  if ((index + 1) % limitPerLine === 0) {
    return `
    ${lastItemStyle}
    width: calc(100% - ${calculateOccupiedWidth(index, limitPerLine)}px);
    &::after {
      border: none
    }
  `;
  }
  if (index % limitPerLine === 0) {
    return `
    ${lastItemStyle}
    width: 110px;
      padding-left: 0;
    `;
  }
  return `
    ${lastItemStyle}
    width: 120px;
    `;
};
export const WorktimeStyled = styled(Col)<{ $index: number; $isLastItem?: boolean }>`
  display: inline-block;
  position: relative;
  padding-left: ${({ $index }) => ($index === 0 ? '0' : '10px')};
  width: ${({ $index }) => ($index === 0 ? '110px' : '120px')};
  padding-right: 10px;
  margin: 0;
  margin-bottom: 8px !important;
  padding-right: 10px;
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 60%;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    border-right: 1px solid black;
  }
  @media screen and (max-width: ${breakpoints.xs}) {
    ${({ $index, $isLastItem }) => getWorktimeStyles($index, 2, $isLastItem)}
  }
  @media screen and (min-width: ${breakpoints.xs}) and (max-width: ${breakpoints.sm}) {
    ${({ $index, $isLastItem }) => getWorktimeStyles($index, 3, $isLastItem)}
  }
  @media screen and (min-width: ${breakpoints.sm}) and (max-width: ${breakpoints.md}) {
    ${({ $index, $isLastItem }) => getWorktimeStyles($index, 4, $isLastItem)}
  }
  @media screen and (min-width: ${breakpoints.md}) and (max-width: ${breakpoints.lg}) {
    ${({ $index, $isLastItem }) => getWorktimeStyles($index, 3, $isLastItem)}
  }
  @media screen and (min-width: ${breakpoints.lg}) and (max-width: ${breakpoints.xl}) {
    ${({ $index, $isLastItem }) => getWorktimeStyles($index, 4, $isLastItem)}
  }
  @media screen and (min-width: ${breakpoints.xl}) and (max-width: ${breakpoints.xxl}) {
    ${({ $index, $isLastItem }) => getWorktimeStyles($index, 5, $isLastItem)}
  }
  @media screen and (min-width: ${breakpoints.xxl}) {
    ${({ $index, $isLastItem }) => getWorktimeStyles($index, 7, $isLastItem)}
  }
`;

export const RejectAndRequestButtonContainerStyled = styled(Col)``;

export const ReviewActionButtonStyled = styled(ButtonWithSpinner)``;

export const ThumbnailStyled = styled.div<{ $src?: string }>`
  width: 50px;
  height: 50px;
  ${({ $src }) => ($src ? `background: url(${$src}) no-repeat;` : '')}
  background-size: contain;
`;

export const BackButtonStyled = styled(Button)`
  & > span {
    color: #d9d9d9;
    font-size: 18px;
    transition: all 0.3s;
  }
  &:hover {
    span {
      color: #28aaeb;
    }
  }
`;

export const DocumentCardCotainerStyled = styled.div`
  border: none;
  background: transparent;
  text-align: left;
  width: 100%;
  padding: 0;
  margin: 0;
`;

export const UserDrawerTabStyled = styled(Tabs)`
  min-height: 100%;
  flex: 1;
  width: 100%;
  & .ant-tabs-content {
    height: 100%;
  }
  & .ant-tabs-nav {
    overflow: hidden;
  }
`;
